module.exports = {"data":{"site":{"siteMetadata":{"title":"Natalia Papounidou"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 102
// module chunks = 60335399758886 114276838955818